import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MapView } from '../components/fishing/MapView';
import { SpotCard } from '../components/fishing/SpotCard';
import { Input } from '../components/ui/Input';
import { spots, Spot } from '../utils/mockData';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
export function MapPage() {
  const navigate = useNavigate();
  const [selectedSpot, setSelectedSpot] = useState<Spot | null>(null);
  const [searchQuery, setSearchQuery] = useState('');
  const filteredSpots = spots.filter(spot => spot.name.toLowerCase().includes(searchQuery.toLowerCase()));
  const handleSpotClick = (spot: Spot) => {
    setSelectedSpot(spot);
  };
  const handleNavigateToDetail = (id: string) => {
    navigate(`/spot/${id}`);
  };
  return <div className="relative h-full w-full flex flex-col md:flex-row" data-id="element-105">
      {/* Search Bar - Floating */}
      <div className="absolute top-4 left-4 right-4 md:left-8 md:w-80 z-20" data-id="element-106">
        <Input placeholder="Search locations..." className="shadow-lg bg-white/90 backdrop-blur-sm dark:bg-slate-800/90 border-transparent" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-107" />
      </div>

      {/* Main Map Area */}
      <div className="flex-1 h-full relative" data-id="element-108">
        <MapView spots={filteredSpots} onMarkerClick={handleSpotClick} selectedSpotId={selectedSpot?.id} data-id="element-109" />
      </div>

      {/* Desktop Sidebar List (Right Side) */}
      <div className="hidden md:block w-96 bg-surface border-l border-border h-full overflow-y-auto p-6" data-id="element-110">
        <h2 className="text-xl font-bold text-text mb-4" data-id="element-111">Nearby Spots</h2>
        <div className="space-y-4" data-id="element-112">
          {filteredSpots.map(spot => <SpotCard key={spot.id} spot={spot} onClick={() => handleNavigateToDetail(spot.id)} compact data-id="element-113" />)}
        </div>
      </div>

      {/* Mobile Bottom Sheet for Selected Spot */}
      <AnimatePresence data-id="element-114">
        {selectedSpot && <motion.div initial={{
        y: '100%'
      }} animate={{
        y: 0
      }} exit={{
        y: '100%'
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 200
      }} className="md:hidden absolute bottom-0 left-0 right-0 z-30 p-4 pb-20 bg-transparent pointer-events-none" data-id="element-115">
            <div className="bg-surface rounded-2xl shadow-2xl overflow-hidden pointer-events-auto relative" data-id="element-116">
              <button onClick={() => setSelectedSpot(null)} className="absolute top-2 right-2 z-10 p-1 bg-black/20 rounded-full text-white" data-id="element-117">
                <X size={16} data-id="element-118" />
              </button>
              <SpotCard spot={selectedSpot} onClick={() => handleNavigateToDetail(selectedSpot.id)} data-id="element-119" />
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}